export const blockIconsToggleStar = (
	<span className='material-symbols-outlined'>star</span>
);
